import Backdrop from '@mui/material/Backdrop';
const defaultProps = {
  BackdropComponent: Backdrop
};
export default {
  defaultProps
};